import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import axios from "../../helpers/axios";

const SyncButton = ({ backorder, onSync }) => {
  const [isLoading, setLoading] = useState(false);
  const syncBackorder = () => {
    if (isLoading) {
      return;
    }

    setLoading(true);
    axios
      .get(`/api/backorders/${backorder.rfdcno}/sync/`)
      .then(() => onSync())
      .catch(() => {})
      .then(() => setLoading(false));
  };

  return (
    <div className="field has-addons mb-0 mr-3">
      <p className="control">
        <a
          className="button is-light"
          disabled={isLoading}
          onClick={syncBackorder}
        >
          <span className="icon is-small">
            <FontAwesomeIcon icon={["fas", "sync-alt"]} />
          </span>
          <span>{isLoading ? "Sincronizando..." : "Sincronizar"}</span>
        </a>
      </p>
    </div>
  );
};

export default SyncButton;
